import React from "react";

/** Editor shell: optional toolbar, scrollable body, save bar pinned at bottom. */
function CmsPageLayout({ children, actions, toolbar }) {
  return (
    <div className="cms-website-editor">
      {toolbar ? (
        <div className="cms-website-editor__toolbar">{toolbar}</div>
      ) : null}
      <div className="cms-website-editor__main">{children}</div>
      {actions}
    </div>
  );
}

export default CmsPageLayout;
